<app-dialog-title [title]="data.title" [state]="data.state"></app-dialog-title>
<p>{{ data.message }}</p>
<div class="row">
	<span class="spacer"></span
	><button
		mat-flat-button
		class="btn-alarm pad-right"
		(click)="dialogRef.close(false)"
	>
		<mat-icon iconPositionEnd>close</mat-icon>
		{{ 'ROOT.STRINGS.CANCEL' | translate }}
	</button>

	<button mat-flat-button class="btn-okay" (click)="dialogRef.close(true)">
		<mat-icon iconPositionEnd>check</mat-icon>
		{{ 'ROOT.STRINGS.APPLY' | translate }}
	</button>
</div>
